import { render, staticRenderFns } from "./bannerContact.vue?vue&type=template&id=52e3dce3&"
import script from "./bannerContact.vue?vue&type=script&lang=js&"
export * from "./bannerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports